import {selectJwtToken, selectUser, setUser} from "../redux/auth";
import {useAppDispatch, useAppSelector} from "../hooks";
import UserApi from "./UserApi";
import {useEffect, useMemo} from "react";
import SystemApi from "./SystemApi";
import {setSystem} from "../redux/system";
import {setMembers} from "../redux/members";
import MemberApi from "./MemberApi";
import LogApi from "./LogApi";
import {setLogEntries} from "../redux/logs";

export default function useApi() {
  const jwtToken = useAppSelector(selectJwtToken)
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectUser)

  const api = useMemo(() => {
    return {
      users: new UserApi(jwtToken),
      systems: new SystemApi(jwtToken),
      members: new MemberApi(jwtToken),
      logs: new LogApi(jwtToken)
    }
  }, [jwtToken])

  useEffect(() => {
    const loadMe = async () => {
      const me = await api.users.me()
      dispatch(setUser(me))
    }

    if (jwtToken) {
      loadMe()
    }
  }, [jwtToken, dispatch, api])

  useEffect(() => {
    const loadSystems = async () => {
      const systems = await api.systems.systems()
      const system = systems[0]
      if (system) {
        dispatch(setSystem(system))
        dispatch(setMembers(system.members))
      }
    }

    const loadLogs = async () => {
      if (user?.defaultSystemId) {
        const logs = await api.logs.logs(user.defaultSystemId)
        dispatch(setLogEntries(logs))
      }
    }

    if (user?.id) {
      loadSystems()
      loadLogs()
    }
  }, [user?.id, user?.defaultSystemId, dispatch, api])

  return api
}